/**
 * PostHog Event Names
 *
 * CRITICAL: Event names must be snake_case for PostHog
 * Values are the exact strings sent to PostHog
 *
 * Story 4.1: PostHog Frontend Analytics
 */
export enum PostHogEvents {
  // Authentication
  USER_LOGGED_IN = "user_logged_in",
  USER_LOGGED_OUT = "user_logged_out",
  USER_SIGNED_UP = "user_signed_up",

  // Page Views
  PAGE_VIEWED = "page_viewed",

  // NFC Scan (CRITICAL for backend partner stats)
  NFC_SCAN = "nfc_scan",

  // Pairing
  PAIRING_STARTED = "pairing_started",
  PAIRING_COMPLETED = "pairing_completed",
  PAIRING_FAILED = "pairing_failed",

  // Trophy Room
  TROPHY_ROOM_VIEWED = "trophy_room_viewed",
  TROPHY_ITEM_VISIBILITY_CHANGED = "trophy_item_visibility_changed",
  TROPHY_ITEM_UNPAIRED = "trophy_item_unpaired",

  // Profile
  PROFILE_VIEWED = "profile_viewed",
  WALLET_ADDED = "wallet_added",
  SOCIAL_LINK_ADDED = "social_link_added",

  // Settings
  SETTINGS_VIEWED = "settings_viewed",
  LANGUAGE_CHANGED = "language_changed",
}
